import React, { Component } from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

import bg from '../../assets/images/sidebar/cat-2.png';

import Button from './../common/button';
import SectionAside from './../common/sectionAside';
import ToggleField from './../common/toggleField';
import InputField from './../common/inputField';
import SelectField from './../common/selectField';
import TextAreaField from './../common/textAreaField';

const Section = Styled.section`
display: grid;
grid-template-columns: 25fr 60fr;
background-color: ${color.tertiary};
height: 100vh;
@media only screen and (max-width: 700px){
grid-template-columns: 1fr;
};
`;

const SectionWrapper = Styled.section`
height: 100vh;
display:grid;
grid-template-rows:  1fr max-content;
place-items:center;
`;

const SectionBody = Styled.section``;

const SectionHeader = Styled.header`
margin: 2rem 0;
`;

const SectionHeading = Styled.h2`
max-width: 30ch;
line-height: 1;
color:${color.primary};
`;

const SectionFooter = Styled.footer`
width: 100%;
background-color:${color.white};
padding: 1rem;
text-align:center;
&>*{margin:0  0.5rem;}
`;

const Pair = Styled.div`
display: flex;
margin: 1rem 0;
&>*:not(:first-child){margin-left:0.5rem;};
@media only screen and (max-width: 700px){
  flex-direction: column;
}
`;

class ScheduleTwo extends Component {
  state = {};

  render() {
    const { onNext, onPrev, onInput } = this.props;

    return (
      <Section>
        <SectionAside
          items={[
            'A photo update for you along with chat about the service',
            'Notifications of sitter arrival and departure times',
            'Treats for your pet, with your permission of course',
          ]}
          image={bg}
        />
        <SectionWrapper>
          <SectionBody>
            <SectionHeader>
              <SectionHeading>
                Okay, we’ll take Ginger for a walk. Just tell us when!
              </SectionHeading>
            </SectionHeader>

            <form>
              <Pair>
                <ToggleField
                  id={'frequency'}
                  label={'Frequency'}
                  onSelect={(e) => onInput(e)}
                  options={[
                    { label: 'Recurring', value: 'Recurring' },
                    { label: 'One time', value: 'One time' },
                  ]}
                />
                <InputField
                  id={'startDate'}
                  label={'Start date'}
                  type={'date'}
                  onBlur={onInput}
                  error={false}
                />
              </Pair>

              <Pair>
                <SelectField
                  id={'days'}
                  label={'Days, select all that apply'}
                  onSelect={(e) => onInput(e)}
                  options={[
                    { label: '1', value: 'mon' },
                    { label: '2', value: 'tue' },
                    { label: '3', value: 'wed' },
                    { label: '4', value: 'thur' },
                    { label: '5', value: 'fri' },
                    { label: '6', value: 'sat' },
                    { label: '7', value: 'sun' },
                  ]}
                />
              </Pair>

              <Pair>
                <SelectField
                  id={'times'}
                  label={'Time, select all that apply'}
                  onSelect={(e) => onInput(e)}
                  options={[
                    { label: 'Morning', value: 'Morning' },
                    { label: 'Afternoon', value: 'Afternoon' },
                    { label: 'Evening', value: 'Evening' },
                  ]}
                />
              </Pair>

              <TextAreaField
                id={'note'}
                label={'Note for your sitter'}
                onBlur={onInput}
                error={false}
                placeHolder={
                  'Route preferences, leash location, treats given, etc.'
                }
              />
            </form>
          </SectionBody>

          <SectionFooter>
            <Button onClick={onPrev} type={'light'} text={'Back'} rounded />
            <Button onClick={onNext} type={'primary'} text={'Next'} rounded />
          </SectionFooter>
        </SectionWrapper>
      </Section>
    );
  }
}

export default ScheduleTwo;
